export const iconFontAwesomeWeatherRainbow = (
	<i className="fa-solid fa-rainbow"></i>
);
